import { DELETE_NOTIFICATION_API, GET_ALL_NOTIFICATION_API } from "./api";
import { GET_ALL_NOTIFICATION, GET_LATEST_NOTIFICATION, DELETE_NOTIFICATION, UPDATE_NEW_NOTIFICATION } from "../reducers/keys";
import HttpClient from "./http-client"; 
import { TOAST_SUCCESS } from "../utils";

export const getAllNotification = (postbody, isLatestNotification) => {
  return async (dispatch) => {
    await new HttpClient().post(GET_ALL_NOTIFICATION_API, postbody).then((response) => {
      const { responseData, responseCode } = response.data;
      if (responseCode === 200) {
        const { notifications, notificationsCount } = responseData;
        if (isLatestNotification) {
          dispatch({
            type: GET_LATEST_NOTIFICATION,
            payload: { notifications, notificationsCount },
          });
        } else {
          const { notifications, notificationsCount } = responseData;
          dispatch({ type: GET_ALL_NOTIFICATION, payload: { notifications, notificationsCount } });
        }
      }
    })
      .catch((ex) => {
        const { data } = ex.response;
        const { responseMessage } = data;
        console.log(responseMessage)
      });
  };
};

export const deleteNotification = (id) => {
  return async (dispatch) => {
    await new HttpClient()
      .delete(`${DELETE_NOTIFICATION_API}/${id}`)
      .then((response) => {
        const { responseMessage, responseCode } = response.data;
        if (responseCode === 200) {
          dispatch({
            type: DELETE_NOTIFICATION,
            payload: id,
          });
          TOAST_SUCCESS(responseMessage, 2000);
        }
      })
      .catch((ex) => {
        const { data } = ex.response;
        const { responseMessage } = data;
        console.log(responseMessage);
      });
  };
}


export const updateNewNotification = (postbody) => {
  return async (dispatch) => {
    await new HttpClient()
      .post(GET_ALL_NOTIFICATION_API, postbody)
      .then((response) => {
        const { responseData, responseCode } = response.data;
        if (responseCode === 200) {
          const { notifications, notificationsCount } = responseData;
          dispatch({
            type: UPDATE_NEW_NOTIFICATION,
            payload: { notifications, notificationsCount },
          });
        }
      })
      .catch((ex) => {
        const { data } = ex.response;
        const { responseMessage } = data;
        console.log(responseMessage)
      });
  };
}

